Ext.define('SA.HistogramCannotSelectLocationPopup', {
    alias: 'widget.histogram-cannot-select-location-popup',
    extend: 'SA.view.PromptWindow',

    cls: 'sa-histogram-cannot-select-location-popup',
    includeHeader: false,
    includeOkBtn: true,

    getBodyItems() {
        var unitPluralName = SA.data.LocationsCache.getPluralGeoUnitName(this.location);

        return {
            xtype: 'component',
            cls: 'sa-histogram-cannot-select-location-popup-message',

            html: [
                '<svg class="sa-histogram-cannot-select-location-popup-message-svg"><use href="#sa-icon-map-info"></use></svg>',
                '<div class="sa-histogram-cannot-select-location-popup-message-text">',
                    `${unitPluralName} cannot be used for histograms because they are the smallest geographic unit.<br><br>`,
                    'Please select a location from a different geographic unit.',
                '</div>'
            ]
        };
    }
});